<template>
    <div class="position-absolute top-0 bottom-0 right-0 left-0 disabled-action">
        <div v-if="ann.open" ref="annBox" class="position-absolute d-flex align-items-center" @mousedown.stop.prevent
            @click.stop>
            <input ref="annInput" type="text" class="form-control form-control-sm border border-primary"
                v-model="ann.text" @keydown.stop @keydown.enter.prevent="saveAnnotation"
                @keydown.esc.prevent="cancelAnnotation" />
            <button class="btn btn-sm btn-light ml-1" @mousedown.stop.prevent @click.stop="saveAnnotation">✔</button>
            <button class="btn btn-sm btn-light ml-1" @mousedown.stop.prevent @click.stop="cancelAnnotation">✕</button>
        </div>
    </div>
    <div class="position-absolute top-0 bottom-0 right-0 left-0 disabled-action">
        <div v-if="ctx.open" ref="ctxMenu" class="position-absolute" @mousedown.stop.prevent @click.stop>
            <div class="dropdown-menu show shadow-sm">
                <button v-if="ctx.isText" class="dropdown-item" type="button" @click.stop.prevent="onCtxEditAnnotation">
                    Edit Text
                </button>
                <button class="dropdown-item" type="button" @click.stop.prevent="onCtxClone">Clone Drawing</button>
                <div class="dropdown-divider"></div>
                <button class="dropdown-item text-danger" type="button" @click.stop.prevent="onCtxDelete">
                    Delete Drawing
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { ensureDrawOverlaysRegistered } from "../utils/drawOverlay";
import { useDrawCore } from "../utils/useDrawCore";
import { useDrawTools } from "../utils/useDrawTools";
import { useDrawFlow } from "../utils/useDrawFlow";
const ui_layer_z = 5;
export default {
    name: "CandlesChartDrawLayer",
    props: {
        chart: { type: Object, required: true },
        rootEl: { type: Object, required: true },
        getBars: { type: Function, required: true },
        getMainPaneId: { type: Function, required: true },
        getIndexByTs: { type: Function, required: true },
    },
    data() {
        return {
            drawing: { createdIds: [] },
            pendingTextTool: null,
            annotationMode: false,
            ann: {
                open: false,
                left: 0,
                top: 0,
                point: null,
                text: "",
                editingId: null,
            },
            drawTool: {
                active: false,
                name: "",
                steps: 0,
                points: [],
                statusCb: null,
            },
            stickerTool: "",
            stickerKind: "arrow",
            stickerStore: new Map(),
            stickerDrag: { active: false, id: null, mode: "", centerPx: null },
            hoverStickerId: null,
            freehand: {
                tool: "",
                drawing: false,
                id: null,
                points: [],
                lastPx: null,
                raf: 0,
                pendingPx: null,
                minDist2: 9,
                maxPoints: 4000,
            },
            ctx: { open: false, x: 0, y: 0, id: null, sub: "", isText: false },
            selectedOverlayId: null,
            overlayMeta: new Map(),
            crossDrag: { active: false, groupId: null },
            continuous: { active: false, groupId: null },
            pendingCallout: null,
            calloutDrag: { active: false },
            _annStyled: false,
            _ctxStyled: false,
        };
    },
    mounted() {
        ensureDrawOverlaysRegistered();
        this._ctx = this.buildCtx();
        Object.assign(this, useDrawCore(this._ctx));
        Object.assign(this, useDrawTools(this._ctx));
        Object.assign(this, useDrawFlow(this._ctx));
        this.rootEl.addEventListener("click", this.onChartClick, { capture: true });
        this.rootEl.addEventListener("contextmenu", this.onContextMenu);
        this.rootEl.addEventListener("pointerdown", this.onRootPointerDown);
        window.addEventListener("pointermove", this.onWinPointerMove, { passive: true });
        window.addEventListener("pointerup", this.onWinPointerUp, { passive: true });
        window.addEventListener("scroll", this.closeCtx, true);
        this.applyIfPresent();
    },
    updated() {
        this.applyIfPresent();
    },
    beforeUnmount() {
        this.rootEl?.removeEventListener("click", this.onChartClick, { capture: true });
        this.rootEl?.removeEventListener("contextmenu", this.onContextMenu);
        this.rootEl?.removeEventListener("pointerdown", this.onRootPointerDown);
        window.removeEventListener("pointermove", this.onWinPointerMove, { passive: true });
        window.removeEventListener("pointerup", this.onWinPointerUp, { passive: true });
        window.removeEventListener("scroll", this.closeCtx, true);
        if (this.freehand.raf) cancelAnimationFrame(this.freehand.raf);
    },
    methods: {
        applyInteractiveLayer(el) {
            if (!el) return;
            el.style.pointerEvents = "auto";
            el.style.zIndex = ui_layer_z;
        },
        applyIfPresent() {
            if (this.ann?.open && this.$refs.annBox && !this._annStyled) {
                this.applyInteractiveLayer(this.$refs.annBox);
                this._annStyled = true;
            }
            if (this.ctx?.open && this.$refs.ctxMenu && !this._ctxStyled) {
                this.applyInteractiveLayer(this.$refs.ctxMenu);
                this._ctxStyled = true;
            }
            if (!this.ann?.open) this._annStyled = false;
            if (!this.ctx?.open) this._ctxStyled = false;
        },
        buildCtx() {
            return {
                vm: this,
                chart: () => this.chart,
                rootEl: () => this.rootEl,
                getBars: () => this.getBars?.(),
                getMainPaneId: () => this.getMainPaneId?.() || "candle_pane",
                getIndexByTs: (ts) => this.getIndexByTs?.(ts),
                nextTick: (fn) => this.$nextTick(fn),
                refs: () => this.$refs,
            };
        },
    },
};
</script>
